import Task from './Task';
import User from './User';

export default {
  Task,
  User,
};
